import React from 'react';
import { Plus } from 'lucide-react';
import type { Rate } from '@/hooks/useGetCustomerRates';
import { quickCharges } from '@/lib/invoiceLines';

interface QuickAddItemsProps {
  availableRates: Rate[];
  onAddItem: (description: string, unitPrice: number) => void;
  disabled?: boolean;
}

const QuickAddItems: React.FC<QuickAddItemsProps> = ({
  availableRates,
  onAddItem,
  disabled = false,
}) => {
  const filteredRates = quickCharges(availableRates);

  if (filteredRates.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <h4 className="text-sm font-bold text-black mb-2">Quick add items</h4>
      <div className="space-y-2">
        {filteredRates.map((charge) => {
          const displayName = charge.description;
          const displayPrice = charge.unitPrice;

          return (
            <button
              key={charge.id}
              onClick={() => onAddItem(displayName, displayPrice)}
              disabled={disabled}
              className="w-full text-left p-3 bg-background rounded-lg border border-gray-200 shadow-md hover:bg-gray-50 transition-colors flex justify-between items-center disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span className="flex items-center gap-2 text-sm text-gray-900">
                <Plus size={14} className="text-primary" />
                {displayName}
              </span>
              <span className="text-sm text-gray-500">
                ${displayPrice.toFixed(2)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickAddItems;
